<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { type TypographyVariants, typographyVariants } from '.'
import { cn } from '@/lib/utils'

const props = defineProps<{
  variant?: TypographyVariants['variant']
  class?: HTMLAttributes['class']
  color?: TypographyVariants['color']
  size?: TypographyVariants['size']
}>()
</script>

<template>
  <span :class="cn(typographyVariants({ variant, color, size }), props.class)">
    <slot />
  </span>
</template>
